import React, { useCallback } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import { ActiveStatus } from "src/apps/commons/dataDisplays";
import { SimpleSubTable } from "src/apps/commons/form";
import { IRemyndProduct } from "../../remyndProduct/types";

interface Props {
  isShow: boolean;
  products: IRemyndProduct[];
  onDelete: (product: IRemyndProduct) => void;
}

const SelectedRemyndProductList: React.FC<Props> = props => {
  const { isShow, products, onDelete } = props;

  const ManageCell = useCallback(
    (data: IRemyndProduct) =>
      isShow ? (
        <IconButton
          aria-label="Delete"
          key={`loading_manage_${data.id}`}
          disabled
        >
          <DeleteIcon />
        </IconButton>
      ) : (
        <IconButton
          aria-label="Delete"
          key={`manage_${data.id}`}
          onClick={() => onDelete(data)}
        >
          <Tooltip title={`ลบ`} placement="top">
            <DeleteIcon />
          </Tooltip>
        </IconButton>
      ),
    [isShow, onDelete]
  );
  const ActiveCell = useCallback(
    (data: IRemyndProduct) => <ActiveStatus value={data.active} />,
    []
  );

  return (
    <SimpleSubTable<IRemyndProduct>
      data={products}
      showIndex={false}
      columns={[
        {
          label: "จัดการ",
          minWidth: 30,
          align: "center",
          renderCell: ManageCell
        },
        {
          label: "รหัส",
          minWidth: 80,
          align: "center",
          renderCell: data => data.code
        },
        {
          label: "ชื่อ (TH)",
          minWidth: 300,
          renderCell: data => data.nameTh
        },
        {
          label: "ชื่อ (EN)",
          minWidth: 300,
          renderCell: data => data.nameEn
        },
        {
          label: "แบรนด์",
          minWidth: 150,
          renderCell: data => data.brand?.nameTh ?? "ไม่ระบุ"
        },
        {
          label: "หมวดสินค้า Lv1",
          minWidth: 200,
          renderCell: data => data.categoryLv1?.nameTh ?? "ไม่ระบุ"
        },
        {
          label: "หมวดสินค้า Lv2",
          minWidth: 200,
          renderCell: data => data.categoryLv2?.nameTh ?? "ไม่ระบุ"
        },
        {
          label: "หมวดสินค้า Lv3",
          minWidth: 200,
          renderCell: data => data.categoryLv3?.nameTh ?? "ไม่ระบุ"
        },
        {
          label: "Active",
          minWidth: 80,
          align: "center",
          renderCell: ActiveCell
        }
      ]}
    />
  );
};

export default SelectedRemyndProductList;
